var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Dislike component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDislike extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon-dislike', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23 12.3529L21.7059 4.21849C21.6134 3.57143 21.3361 3.10924 20.8739 2.64706C20.4118 2.27731 19.8571 2 19.2101 2H8.94958C8.30252 2.09244 7.7479 2.27731 7.19328 2.55462L6.08403 3.01681H2.47899C2.10924 3.01681 1.7395 3.20168 1.46218 3.47899C1.18487 3.7563 1 4.12605 1 4.4958V12.8151C1 13.1849 1.18487 13.5546 1.46218 13.8319C1.7395 14.1092 2.10924 14.2941 2.47899 14.2941H5.9916L9.78151 20.3025C9.96639 20.6723 10.3361 20.9496 10.7059 21.1345C11.0756 21.3193 11.4454 21.4118 11.8151 21.4118H11.9076C12.1849 21.4118 12.4622 21.3193 12.7395 21.2269C13.0168 21.1345 13.2941 20.9496 13.5714 20.6723C13.8487 20.4874 14.0336 20.2101 14.126 19.8403C14.2185 19.563 14.3109 19.1933 14.3109 18.916V15.2185H20.5042C20.874 15.2185 21.2437 15.1261 21.521 14.9412C21.7983 14.7563 22.0756 14.5714 22.3529 14.2941C22.5378 14.0168 22.7227 13.7395 22.8151 13.3697C23 13.0924 23 12.7227 23 12.3529ZM5.71429 13H2.47899L2.38655 12.9076V4.4958C2.38655 4.4958 2.38655 4.4958 2.47899 4.4958H5.71429V13ZM21.521 13.0924C21.521 13.2773 21.4286 13.3697 21.3361 13.4622C21.2437 13.5546 21.1513 13.6471 20.9664 13.7395C20.7815 13.8319 20.6891 13.8319 20.5042 13.8319H13.5714C13.2017 13.8319 12.8319 14.1092 12.8319 14.5714V19.1008C12.8319 19.2857 12.8319 19.3782 12.7395 19.4706C12.6471 19.563 12.6471 19.7479 12.4622 19.8403C12.3697 19.9328 12.2773 20.0252 12.0924 20.0252C12 20.1176 11.8151 20.1176 11.6303 20.1176C11.4454 20.1176 11.2605 20.1176 11.1681 20.0252C10.9832 19.9328 10.8908 19.8403 10.7983 19.6555L6.91597 13.4622V4.12605L7.65546 3.7563C8.02521 3.57143 8.39496 3.47899 8.76471 3.47899H19.1176C19.395 3.47899 19.6723 3.57143 19.8571 3.7563C20.1345 3.94118 20.3193 4.21849 20.3193 4.4958L21.6134 12.6303C21.6134 12.7227 21.6134 12.9076 21.521 13.0924Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconDislike.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDislike.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconDislike.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconDislike.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-dislike') === undefined) {
    customElements.define('cat-icon-dislike', BlocksIconDislike);
}
